module.exports = __webpack_public_path__ + "fonts/fira-sans-v8-latin-300.e98236c.woff";